import { useEffect,useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Link,useLocation } from "react-router-dom";

import { Pagination,Table } from "antd";
import { formatDateHandler2,toTitleCase } from "utils/common";
import { itemRender,pageSizeOptions } from "utils/table";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import AllDocumentAddPopup from "../../../../components/modelpopup/AllDocumentAddPopup";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import DocumentListFilter from "../components/DocumentListFilter";

import { deleteDocumentApi, exportDocumentsApi } from "api/services/documents";
import { Button } from "components/Button";
import DocumentsFilterDrawer from "components/Drawer/documentsFilterDrawer";
import Image from "components/Image";
import { SkeltonLoader } from "components/skeltonLoader";
import { useSelector } from "react-redux";
import { Bounce,toast } from "react-toastify";
import { useDocument } from "../context/documentContext";

const AllDocuments = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const location = useLocation();
  const {
    loading,
    setLoading,
    searchText,
    documentData,
    view,
    setView,
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,

    handleDocumentDetailPage,
    handleDateChange,
    handleClearAll,
    createDocumentHandler,
    documentModal,
    setDocumentModal,
    setSelectedDocument,
    selectedDocument,
    getDocumentList,

    documentType,
    storeType,
    documentTypeLoading,
    setStoreType,
    resetDocumentList,
    getExportParams,
    isFilterDirty,
  } = useDocument();
  const {
    user,
    userLoading
  } = useSelector((state) => state.user);
  const [deleteModal, setDeleteModal] = useState(false);

  const handleEditDocument = (item) => {
    setDocumentModal(true);
  };
  const columns = [
    {
      title: "Employee Name",
      dataIndex: "company_user__user__first_name",
      sorter: true,
      render: (text, record, index) => (
        <h2 className="table-avatar d-flex">
          <a
            onClick={() => handleDocumentDetailPage(record.id, index)}
            className="avatar"
          >
            <Image src={record.company_user?.profile_image} type="user" style={{ objectFit: "cover" }} />
          </a>
          <a
            onClick={() => handleDocumentDetailPage(record.id, index)}
            className="profile-split d-flex flex-column"
          >
            {record.company_user?.first_name} {record.company_user?.last_name}{" "}
            <span className="small text-muted">
              {record.company_user?.emp_no}
            </span>
          </a>
        </h2>
      ),
    },
 
    {
      title: "Document Name",
      dataIndex: "name",
      sorter: true,

      render: (text, record) => (
        <div className="profile-split d-flex flex-column">
          <span className="table-avatar">{record.name}</span>
         
        </div>
      ),
    },

    // {
    //   title: "Document No",
    //   dataIndex: "document_number",
    //   render: (text, record) => (
    //     <span className="table-avatar">{record.document_number}</span>
    //   ),
    // },

    {
      title: "Type",
      dataIndex: "document_type__name",
      sorter: true,
      align:"center",
      render: (text, record) => (
        <div className="dropdown">
          <span className="badge badge-soft-info">
            {record.document_type?.name}
          </span>
        </div>
      ),
    },

    {
 title: "Attachments",
      dataIndex: "document_sub_type",
      // sorter: true,
      align:"center",
      render: (text, record) => (
        <div className="dropdown">
        <span className="small text-muted">
              {" "}
              <i class="fa-solid fa-paperclip" /> {record.attachments_count}{" "}
              Attachments{" "}
            </span>
        </div>
      ),
    },
    

    {
      title: "Issue Date",
      dataIndex: "issue_date",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {formatDateHandler2(record.issue_date)}
        </span>
      ),
    },

    {
      title: "Expiry Date",
      dataIndex: "expiry_date",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {formatDateHandler2(record.expiry_date)}
        </span>
      ),
    },
    {
      title: "Expires In",
      // expiry_in_days is computed from expiry_date on the backend, so
      // sorting by expiry_date gives the same order server-side.
      dataIndex: "expiry_date",
      key: "expiry_in_days",
      sorter: true,
      align:"center",
      render: (text, record) => (
        <span className="table-avatar">{(record.expiry_in_days && record.expiry_in_days > 0) ? `${record.expiry_in_days} day(s)` : "N/A"}</span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: true,
      align:"center",
      render: (text, record) => (
        <div className="dropdown">
          <span
            className={`badge badge-soft-${record.is_expired ? "danger" : "success"}`}
          >
            {record.is_expired ? "Expired" : "Active"}
          </span>
        </div>
      ),
    },
    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   sorter: true,
    //   render: (text, record) => (
    //     <span className="table-avatar">
    //       {record.description}
    //     </span>
    //   )

    // },
    {
      title: "Action",
      render: (text, record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            {/* <Link
            onClick={()=>{
              handleEditDocument(recort)
              setDocumentModal(true)
              // setSelectedDocument(record)

            }}
              // to="#"
              className="dropdown-item"
              // data-bs-toggle="modal"
              // data-bs-target="#edit_job"
            >
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link> */}
            {
                (user?.role?.access_scope == "all" || user?.id == record?.company_user?.id )&&
              <Link
              onClick={() => {
                setDeleteModal(true);
                setSelectedDocument(record);
              }}
              to="#"
              className="dropdown-item"
              // data-bs-toggle="modal"
              // data-bs-target="#delete"
            >
              <i className="fa fa-trash m-r-5" /> Delete
            </Link>
            }
          
          </div>
        </div>
      ),
    },
  ];
  useEffect(()=>{
    // Only reset on initial mount, not on every render
    const currentUser = new URLSearchParams(window.location.search).get("company_user");
    if (!currentUser) {
    resetDocumentList()
    }
    setStoreType("user")
  },[])
  
  // Reset when navigating back to this page from detail page
  useEffect(() => {
    if (location.pathname === '/documents' || location.pathname === '/documents/') {
      const currentUser = new URLSearchParams(window.location.search).get("company_user");
      // If URL doesn't have company_user but state does, reset
      if (!currentUser && pageSettings?.user) {
        resetDocumentList();
      }
    }
  }, [location.pathname])
  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
         {
          documentData.length == 0 &&
          <div className="row">
            <div className="col-12">
              <h4 className="user-name m-t-10 mb-0 text-ellipsis text-start">
                <a>No documents found</a>
              </h4>
            </div>
          </div>
        }
          {documentData.map((document, index) => (
            <div
              className="col-12 col-sm-6 col-md-4 col-lg-3"
              key={document.id}
              style={{
                ...(isMobile ? { paddingLeft: "4px", paddingRight: "4px", marginBottom: "12px" } : { marginBottom: "16px" }),
                display: "flex"
              }}
            >
              <div className="card shadow-sm" style={{ 
                borderRadius: "8px", 
                border: "none",
                background: "linear-gradient(135deg, #ffffff 0%, #fef2f2 100%)",
                margin: 0,
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                position: "relative",
                overflow: "hidden",
                cursor: "pointer",
                transition: "all 0.2s ease",
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
              }}
              onClick={() => handleDocumentDetailPage(document.id, index)}
              >
                {/* Action Menu */}
                <div style={{
                  position: "absolute",
                  top: "8px",
                  right: "8px",
                  zIndex: 10
                }}>
                  <div className="dropdown">
                  <Link
                      to="#"
                    className="action-icon dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        width: "28px",
                        height: "28px",
                        borderRadius: "6px",
                        background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#ffffff",
                        textDecoration: "none",
                        boxShadow: "0 2px 6px rgba(211, 0, 26, 0.3)",
                        cursor: "pointer",
                        transition: "all 0.2s ease"
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "scale(1.1)";
                        e.currentTarget.style.boxShadow = "0 4px 10px rgba(211, 0, 26, 0.4)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "scale(1)";
                        e.currentTarget.style.boxShadow = "0 2px 6px rgba(211, 0, 26, 0.3)";
                      }}
                    >
                      <i className="fa-solid fa-ellipsis-vertical" style={{ fontSize: "12px" }}></i>
                    </Link>
                    <div className="dropdown-menu dropdown-menu-right">
                      {(user?.role?.access_scope == "all" || user?.id == document?.company_user?.id) && (
                    <Link
                      className="dropdown-item"
                          onClick={(e) => {
                            e.stopPropagation();
                        setDeleteModal(true);
                        setSelectedDocument(document);
                      }}
                          to="#"
                    >
                      <i className="fa-regular fa-trash-can m-r-5" /> Delete
                    </Link>
                      )}
                    </div>
                  </div>
                </div>

                <div className="card-body" style={{ 
                  padding: isMobile ? "12px" : "16px",
                  flex: 1,
                  display: "flex",
                  flexDirection: "column"
                }}>
                  {/* Document Name - Main Highlight */}
                  <div style={{ marginBottom: "12px", paddingRight: "36px" }}>
                    <h4 style={{ 
                      fontSize: isMobile ? "15px" : "16px",
                      fontWeight: "600",
                      color: "#1f2937",
                      marginBottom: "6px",
                      lineHeight: "1.3"
                    }}>
                      {document?.name || "Untitled Document"}
                    </h4>
                    {document?.document_type?.name && (
                      <span style={{
                        fontSize: "12px",
                        color: "#6b7280",
                        fontWeight: "400"
                      }}>
                        {document.document_type.name}
                      </span>
                    )}
                  </div>

                  {/* Employee Info */}
                  {document?.company_user && (
                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginBottom: "12px"
                    }}>
                      <div style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "50%",
                        overflow: "hidden",
                        border: "2px solid #e5e7eb",
                        flexShrink: 0,
                        background: "#ffffff"
                      }}>
                        <Image 
                          src={document.company_user?.profile_image} 
                          type="user" 
                          style={{ objectFit: "cover", width: "100%", height: "100%" }}
                        />
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ 
                          fontSize: "13px", 
                          color: "#1f2937",
                          fontWeight: "600",
                          marginBottom: "2px"
                        }}>
                          {document.company_user?.first_name} {document.company_user?.last_name}
                        </div>
                        <div style={{ 
                          fontSize: "11px", 
                          color: "#6b7280",
                          marginBottom: "2px"
                        }}>
                          {document.company_user?.emp_no}
                        </div>
                        {document.company_user?.position_name && (
                          <div style={{ 
                            fontSize: "11px", 
                            color: "#6b7280",
                            marginBottom: "2px"
                          }}>
                            {document.company_user.position_name}
                          </div>
                        )}
                        {document.company_user?.email && (
                          <div style={{ 
                            fontSize: "11px", 
                            color: "#6b7280"
                          }}>
                            {document.company_user.email}
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Document Details */}
                  <div style={{ marginTop: "auto" }}>
                    <div className="row g-2" style={{ marginBottom: "10px" }}>
                      {document?.issue_date && (
                        <div className="col-6">
                          <div style={{ fontSize: "10px", color: "#9ca3af", marginBottom: "3px", fontWeight: "500" }}>
                            <i className="la la-calendar" style={{ marginRight: "4px" }}></i>
                            Issue Date
                          </div>
                          <div style={{ fontSize: "11px", color: "#374151", fontWeight: "500" }}>
                            {formatDateHandler2(document.issue_date)}
                          </div>
                        </div>
                      )}
                      {document?.expiry_date && (
                        <div className="col-6">
                          <div style={{ fontSize: "10px", color: "#9ca3af", marginBottom: "3px", fontWeight: "500" }}>
                            <i className="la la-calendar-check" style={{ marginRight: "4px" }}></i>
                            Expiry Date
                          </div>
                          <div style={{ fontSize: "11px", color: "#374151", fontWeight: "500" }}>
                            {formatDateHandler2(document.expiry_date)}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Attachments and Status */}
                    <div style={{ 
                      display: "flex", 
                      justifyContent: "space-between", 
                      alignItems: "center"
                    }}>
                      {document?.attachments_count !== undefined && (
                        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                          <i className="fa-solid fa-paperclip" style={{ fontSize: "11px", color: "#6b7280" }}></i>
                          <span style={{ fontSize: "11px", color: "#6b7280", fontWeight: "500" }}>
                            {document.attachments_count} {document.attachments_count === 1 ? 'File' : 'Files'}
                          </span>
                    </div>
                      )}
                      <span style={{
                        padding: "3px 8px",
                        borderRadius: "4px",
                        fontSize: "10px",
                        fontWeight: "600",
                        background: document?.is_expired ? "#fee2e2" : "#d1fae5",
                        color: document?.is_expired ? "#991b1b" : "#065f46"
                      }}>
                        {document?.is_expired ? "Expired" : "Active"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      );
    }
  };

  const deleteHandler = (props) => {
    console.log(selectedDocument, "LLLLLLLL");
    deleteDocumentApi(selectedDocument?.id)
      .then((res) => {
        toast.success("Document deleted successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        getDocumentList();
        setDeleteModal(false);
      })
      .catch((e) => {
        toast.error("Error deleting document!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      });
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle={toTitleCase(storeType) + " Documents"}
            title="Dashboard"
            subtitle="Documents"
            modal="#add_document"
            name="Add Document"
            view={view}
            setDocumentModal={setDocumentModal}
            setView={setView}
          />

          <DocumentListFilter
            filters={filters}
            handleInputChange={handleInputChange}
            searchPlaceholder={"Search Documents"}
            handleFilterDrawer={handleFilterDrawer}
            handleFilterChange={handleFilterChange}
            loading={loading}
            storeType={storeType}
            setStoreType={setStoreType}
            documentType={documentType}
            exportApiFn={exportDocumentsApi}
            exportParams={getExportParams()}
            exportFilename={`${toTitleCase(storeType)} Documents.xlsx`}
          />

          {view == "grid" ? (
            <div className="row">
              <GridView />
              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                  <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}
                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                        );
                      }
                      return null;
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-12">
                <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                  <style>{`
                    .modern-table .ant-table-tbody > tr {
                      background-color: #ffffff !important;
                    }
                    .modern-table .ant-table-tbody > tr:hover > td {
                      background-color: #f5f5f5 !important;
                    }
                    .modern-table .ant-table-thead > tr > th {
                      background-color: #f8f9fa !important;
                      font-weight: 600;
                      color: #333;
                      border-bottom: 2px solid #e0e0e0;
                      padding: 10px 12px;
                      font-size: 13px;
                    }
                    .modern-table .ant-table-tbody > tr > td {
                      border-bottom: 1px solid #f0f0f0;
                      padding: 10px 12px;
                      font-size: 13px;
                    }
                    .modern-table .ant-table-wrapper .ant-table-pagination.ant-pagination {
                      border-top: 1px solid #f0f0f0;
                      background-color: #ffffff;
                      border-bottom-left-radius: 12px;
                      border-bottom-right-radius: 12px;
                    }
                  `}</style>
                  <div className="table-responsive" style={{ overflowX: "auto" }}>
                    <Table
                      className="mb-0 modern-table"
                      style={{ 
                        borderRadius: "12px",
                        minWidth: "100%"
                      }}
                      scroll={{ x: "max-content" }}
                      columns={columns}
                      dataSource={documentData}
                      rowKey={(record) => record.id}
                      loading={loading}
                      pagination={{
                        total: pageSettings?.total,
                        pageSize: pageSettings?.pageSize,
                        showSizeChanger: true,
                        pageSizeOptions: pageSizeOptions,
                        itemRender: itemRender,
                        position: "right",
                        current: pageSettings?.page,
                        showTotal: (total, range) =>
                          `${range[0]}-${range[1]} of ${total} items`,
                        style: { padding: "16px" }
                      }}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}


          <AllDocumentAddPopup
            documentType={documentType}
            documentTypeLoading={documentTypeLoading}
            getDocumentList={getDocumentList}
            setSelectedDocument={setSelectedDocument}
            setLoading={setLoading}
            selectedDocument={selectedDocument}
            loading={loading}
            createDocumentHandler={createDocumentHandler}
            documentModal={documentModal}
            setDocumentModal={setDocumentModal}
            storeType={storeType}
          />
          {/* Delete Modal */}
          <DeleteModal
            deleteModal={deleteModal}
            setDeleteModal={setDeleteModal}
            deleteHandler={deleteHandler}
            Name="Delete Record"
          />
        </div>
      </div>

      <DocumentsFilterDrawer
        searchPlaceholder={"Search Documents"}
        showFilterDrawer={showFilterDrawer}
        handleFilterDrawer={handleFilterDrawer}
        handleFilterChange={handleFilterChange}
        filters={filters}
        handleInputChange={handleInputChange}
        handleApplyFilter={handleApplyFilter}
        filterLoading={filterLoading}
        handleDateChange={handleDateChange}
        handleClearAll={handleClearAll}
        documentType={documentType}
        storeType={storeType}
        isFilterDirty={isFilterDirty}
      />
      {/* Delete Modal */}
    </>
  );
};

export default AllDocuments;
